export const injectAnalytics = (code) => {
    const sc1 = document.createElement(`script`);
    sc1.setAttribute(`async`, ``);
    sc1.setAttribute(`src`, `https://www.googletagmanager.com/gtag/js?id=${ code }`);
    document.body.append(sc1);

    const sc2 = document.createElement(`script`);
    sc2.innerHTML = `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', '${ code }');`
    document.body.append(sc2);
}